import React, { useState } from "react";

const contactOptions = [
  "Advanced Custom Reports Request",
  "Suggestions",
  "Help/Support",
  "Feedback",
  "Enquiry"
];

export default function ContactUs() {
  const [selectedOption, setSelectedOption] = useState(contactOptions[0]);
  const [message, setMessage] = useState("");

  return (
    <form
      className="bg-white/95 p-6 rounded-lg shadow-md border"
      onSubmit={e => {
        e.preventDefault();
        alert("Message sent! (Demo only)");
      }}
    >
      <div className="mb-2">
        <label className="block font-semibold text-gray-700 mb-1">Contact us:</label>
        <select
          value={selectedOption}
          onChange={e => setSelectedOption(e.target.value)}
          className="w-full p-2 rounded border border-gray-300"
        >
          {contactOptions.map(option => (
            <option key={option}>{option}</option>
          ))}
        </select>
      </div>
      <div className="mb-2">
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          className="w-full p-2 rounded border border-gray-300"
          placeholder="Type your message (max 200 words)"
          rows={4}
          maxLength={1500}
        />
      </div>
      <button
        type="submit"
        className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 font-semibold transition"
      >
        Submit
      </button>
    </form>
  );
}